module.exports = __webpack_public_path__ + "img/guangdian.7f8feaf8.jpg";